module.exports = __webpack_public_path__ + "static/img/covid_thumbnail.ee0ab8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/covid_thumbnail.png
// module id = /XFK
// module chunks = 9